import * as React from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Layout } from "../components/layout"
import { Head } from "../components/seo"

export const NotFoundPage = () => {
  const { t } = useTranslation("translations", { keyPrefix: "404" })

  return (
    <Layout title="404" subtitle="not found">
      <Head title="404: Not found" />
      <Container>
        <div className="my-5 d-flex flex-column align-items-center">
          <h4 className="my-3">{t("CONTENT_TITLE")}</h4>
          <p>{t("REASONS")}</p>
          <ul>
            <li>{t("REASONS_1")}</li>
            <li>{t("REASONS_2")}</li>
            <li>{t("REASONS_3")}</li>
          </ul>
        </div>
        <Row>
          <Col sm={{ span: 4, offset: 4 }}>
            <a href="/">
              <Button variant="outline-dark" className="w-100 rounded-0 mb-5">
                {t("BUTTON_BACK")}
              </Button>
            </a>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}